import FormattedMessage from 'I18n/components/FormattedMessage';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getContentModelAudienceAccessLists, getContentModelPublicAccessRules
// @ts-expect-error Untyped module
} from 'page-editor-ui/redux/selectors/pageContentModelSelectors';
import { getAccessIdsLength } from 'ui-memberships-settings-lib/utils/publicAccessRuleTypes';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getContactListsForContentRequest, getContactRegistrationListsRequest
// @ts-expect-error Untyped module
} from 'page-editor-ui/redux/selectors/pageRequestStatesSelectors';
// @ts-expect-error Untyped module
import { getPageSettingsContactListsForContent } from 'page-editor-ui/redux/selectors/pageSettingsSelectors';
import UIExpandableSection from 'UIComponents/accordion/UIExpandableSection';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import ContentRoutes from 'ContentUtils/Routes';
import { fetchContactListRegistrations, fetchContactListsForContent
// @ts-expect-error Untyped module
} from 'page-editor-ui/redux/actions/pageSettingsActions';
import { requestFailedOrUninitialized } from 'redux-request-state/util/requestStateCheckers';
import AudienceAccessTypes from 'ContentUtils/constants/AudienceAccessTypes';
import useAudienceAccessType from '../hooks/useAudienceAccessType';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AudienceAcccessAlertTitle = styled.span.withConfig({
  displayName: "PatagoniaPageAudienceAccessMsg__AudienceAcccessAlertTitle",
  componentId: "sc-1sy529u-0"
})(["text-transform:uppercase;"]);
const PatagoniaPageAudienceAccessMsg = () => {
  const contactListRegistrationsRequest = useSelector(getContactRegistrationListsRequest);
  const contactListsForContentRequest = useSelector(getContactListsForContentRequest);
  const contactListsWithAccess = useSelector(getContentModelAudienceAccessLists);
  const contactListsForContent = useSelector(getPageSettingsContactListsForContent);
  const audienceAccessType = useAudienceAccessType();
  const publicAccessRules = useSelector(getContentModelPublicAccessRules);
  const accessListCount = getAccessIdsLength(publicAccessRules);
  const [listsOpen, setListsOpen] = useState(false);
  const dispatch = useDispatch();
  const showListsSection = !!contactListsForContent && !contactListsForContent.isEmpty() && (AudienceAccessTypes.SPECIFIC_CONTACTS === audienceAccessType || AudienceAccessTypes.SSO_WITH_SPECIFIC_CONTACTS === audienceAccessType);
  useEffect(() => {
    if (requestFailedOrUninitialized(contactListRegistrationsRequest)) {
      dispatch(fetchContactListRegistrations(contactListsWithAccess));
    }
    if (requestFailedOrUninitialized(contactListsForContentRequest)) {
      dispatch(fetchContactListsForContent(contactListsWithAccess));
    }
  }, [contactListRegistrationsRequest, contactListsForContentRequest, contactListsWithAccess, dispatch]);
  if (audienceAccessType === AudienceAccessTypes.ALL) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIAlert, {
      type: "info",
      className: "m-top-4",
      titleText: /*#__PURE__*/_jsx(AudienceAcccessAlertTitle, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "publishConfirmModal.audienceAccess.title"
        })
      }),
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `publishConfirmModal.audienceAccess.${audienceAccessType}`,
        options: {
          count: accessListCount
        }
      })
    }), showListsSection ? /*#__PURE__*/_jsx(UIExpandableSection, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `publishConfirmModal.audienceAccess.lists.${listsOpen ? 'hide' : 'show'}`
      }),
      onOpenChange: ({
        target: {
          value
        }
      }) => {
        setListsOpen(value);
      },
      className: "m-top-4",
      indentation: "compact",
      children: /*#__PURE__*/_jsx(UIList, {
        children: contactListsForContent.map(contactList => {
          const listId = contactList.get('listId');
          return /*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "publishConfirmModal.audienceAccess.lists.listWithContacts_jsx",
              options: {
                count: contactList.getIn(['metaData', 'size']),
                href: ContentRoutes.list(listId),
                listName: contactList.get('name'),
                external: true
              },
              elements: {
                UILink
              }
            })
          }, listId);
        })
      })
    }) : null]
  });
};
export default PatagoniaPageAudienceAccessMsg;